import React, { useEffect, useState } from 'react'
import ContentServiceApi from '../../api/content-service/content-service.api';

function Alert({ logged, setHasAlert, showAlert }) {

  const [alert, setAlert] = useState({});
  const [alertDisplay, setAlertDisplay] = useState(false);
  const [idAlertSessionStorage, setIdAlertSessionStorage] = useState('closedByUser');

  const TODOS = 'T';
  const SOMENTE_LOGADOS = 'SL';
  const SOMENTE_NAO_LOGADOS = 'SNL'

  function setCurrentAlert(alertData) {
    setAlert(alertData)
  }

  function available() {
    setHasAlert(true);
    setAlertDisplay(true);
  }

  function unavailable() {
    setHasAlert(false);
    setAlertDisplay(false);
  }

  function setVisibilityBySegmentation(isLogged, segmentation) {

    if (
      (segmentation) &&
      (segmentation !== TODOS) &&
      (
        (segmentation === SOMENTE_LOGADOS && !isLogged) ||
        (segmentation === SOMENTE_NAO_LOGADOS && isLogged)
      )
    ) {
      unavailable();
    }
  }

  useEffect(() => {

    ContentServiceApi.getCurrentAlert()
      .then((alert) => {
        
        if (alert) {

          const currentIdAlertSessionStorage = `closedByUser_alert_${alert.id}`;
          setIdAlertSessionStorage(currentIdAlertSessionStorage);
          const alertSuppressedByUser = sessionStorage && sessionStorage.getItem(currentIdAlertSessionStorage);
          if (alertSuppressedByUser) {
            unavailable();
            return;
          }

          setCurrentAlert(alert)
          available();
          setVisibilityBySegmentation(logged, alert.segmentation)
        }
      })
      .catch(function (error) {
        unavailable();
        return;
      });

  }, [logged]);

  const closeAlert = () => {
    unavailable();
    sessionStorage.setItem(idAlertSessionStorage, true);
  };

  return (
    <div role="alert" className={`alerta-live ${(alertDisplay && showAlert) ? "show-alert" : "hide-alert"}`} >
      <p id="alerta-texto" className="alerta-texto">
        <span className="alert-content">{alert.content}&nbsp;</span>
        <a className="eva-link-preto" href={alert.link} target="_blank" rel="noopener" >{alert.linkLabel}</a>
      </p>
      <button onClick={() => { closeAlert() }} aria-label="Fechar alerta" className="alerta-fechar">
        <i className="fa-regular  fa-xmark"></i>
      </button>
    </div>
  )
}

export default Alert